/* tslint:disable */

/**
 * Collaborative documenting
 * Collaborative documenting Api specification
 *
 * OpenAPI spec version: 1.0.0
 * Contact: support@example.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export enum CoObjectTypeEnum {
  TABLE = "TABLE",
  TABLE_CELL = "TABLE_CELL",
  CHECKBOX = "CHECKBOX",
  DROPDOWN_LIST = "DROPDOWN_LIST",
  CHART = "CHART",
  FREE_TEXT = "FREE_TEXT",
  DOCUMENT_PART_INCLUDE = "DOCUMENT_PART_INCLUDE",
  AMOUNT = "AMOUNT",
  AMOUNT_AIH = "AMOUNT_AIH",
  DIMENSION_ATTRIBUTE = "DIMENSION_ATTRIBUTE",
  TGK_TEXT = "TGK_TEXT",
  TABLE_SA = "TABLE_SA",
  CHART_SA = "CHART_SA",
  AMOUNT_SA = "AMOUNT_SA",
}
